import { render, staticRenderFns } from "./client-bonuses-editor.pug?vue&type=template&id=49371e07&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./client-bonuses-editor.scss?vue&type=style&index=0&id=49371e07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49371e07",
  null
  
)

export default component.exports